import React from "react";
import { cn } from "../../lib/utils";

const AppShell = ({ children, sidebar, header, className = "" }) => (
  <div
    className={cn(
      "min-h-screen bg-neutral-50 text-neutral-900 dark:bg-neutral-950 dark:text-neutral-50",
      className,
    )}
    dir="rtl"
  >
    {sidebar}
    <div className="min-h-screen">
      {header}
      <main
        id="main-content"
        className="mx-auto w-full max-w-[1440px] px-4 py-6 md:px-6 lg:px-8"
      >
        {children}
      </main>
    </div>
  </div>
);

export default AppShell;
